"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function mapToCtaBarProps({ data, mappers }) {
    let ctaBar = null;
    if (!('blockType' in data)) {
        ctaBar = data;
    }
    else if (data.ctaBarReference && typeof data.ctaBarReference === 'object') {
        ctaBar = data.ctaBarReference;
    }
    return {
        leftBlock: ctaBar?.leftBlock && mappers.mapRichText({ richText: ctaBar?.leftBlock, mappers }),
        middleBlock: ctaBar?.middleBlock && mappers.mapRichText({ richText: ctaBar?.middleBlock, mappers }),
        rightBlock: ctaBar?.rightBlock && mappers.mapRichText({ richText: ctaBar?.rightBlock, mappers }),
        backgroundColor: ctaBar?.backgroundColor?.toLowerCase(),
        textColor: ctaBar?.textColor?.toLowerCase(),
        leftDivider: ctaBar?.leftDivider,
        middleDivider: ctaBar?.middleDivider,
        sticky: ctaBar?.sticky,
    };
}
exports.default = mapToCtaBarProps;
